class Transaction {
  constructor() {
    this.reference = "";
    this.status = "";
    this.statusCode = "";
    this.startTimestamp = "";
    this.endTimestamp = "";
    this.paymentUrl = "";
    this.operationName = "";
    this.operationType = "";

    this.operationNameDisplay = "";
    this.operationTypeDisplay = "";
    this.statusToDisplay = "";
    this.logo = "";
    this.startDate = "";
    this.endDate = "";
    this.paymentReason = "";
    this.statusMessage = "";

    this.amountToSend = "";
    this.currencyToSend = "";
    this.amountToReceive = "";
    this.currencyToReceive = "";
    this.fee = "";
    this.feeCurrency = "";

    this.senderFirstName = "";
    this.senderLastName = "";
    this.recipientFirstName = "";
    this.recipientLastName = "";
    this.senderAccount = "";
    this.recipientAccount = "";

    this.metaData = {};
  }

  setReference(reference) {
    this.reference = reference;
    return this;
  }

  getReference() {
    return this.reference;
  }

  setStatus(status) {
    this.status = status;
    return this;
  }

  getStatus() {
    return this.status;
  }

  setStatusCode(statusCode) {
    this.statusCode = statusCode;
    return this;
  }

  getStatusCode() {
    return this.statusCode;
  }

  setStartTimestamp(startTimestamp) {
    this.startTimestamp = startTimestamp;
    return this;
  }

  getStartTimestamp() {
    return this.startTimestamp;
  }

  setEndTimestamp(endTimestamp) {
    this.endTimestamp = endTimestamp;
    return this;
  }

  getEndTimestamp() {
    return this.endTimestamp;
  }

  setPaymentUrl(paymentUrl) {
    this.paymentUrl = paymentUrl;
    return this;
  }

  getPaymentUrl() {
    return this.paymentUrl;
  }

  setOperationName(operationName) {
    this.operationName = operationName;
    return this;
  }

  getOperationName() {
    return this.operationName;
  }

  setOperationType(operationType) {
    this.operationType = operationType;
    return this;
  }

  getOperationType() {
    return this.operationType;
  }

  setOperationNameDisplay(operationNameDisplay) {
    this.operationNameDisplay = operationNameDisplay;
    return this;
  }

  getOperationNameDisplay() {
    return this.operationNameDisplay;
  }

  setOperationTypeDisplay(operationTypeDisplay) {
    this.operationTypeDisplay = operationTypeDisplay;
    return this;
  }

  getOperationTypeDisplay() {
    return this.operationTypeDisplay;
  }

  setStatusToDisplay(statusToDisplay) {
    this.statusToDisplay = statusToDisplay;
    return this;
  }

  getStatusToDisplay() {
    return this.statusToDisplay;
  }

  setLogo(logo) {
    this.logo = logo;
    return this;
  }

  getLogo() {
    return this.logo;
  }

  setStartDate(startDate) {
    this.startDate = startDate;
    return this;
  }

  getStartDate() {
    return this.startDate;
  }

  setEndDate(endDate) {
    this.endDate = endDate;
    return this;
  }

  getEndDate() {
    return this.endDate;
  }

  setPaymentReason(paymentReason) {
    this.paymentReason = paymentReason;
    return this;
  }

  getPaymentReason() {
    return this.paymentReason;
  }

  setStatusMessage(statusMessage) {
    this.statusMessage = statusMessage;
    return this;
  }

  getStatusMessage() {
    return this.statusMessage;
  }

  setAmountToSend(amountToSend) {
    this.amountToSend = amountToSend;
    return this;
  }

  getAmountToSend() {
    return this.amountToSend;
  }

  setCurrencyToSend(currencyToSend) {
    this.currencyToSend = currencyToSend;
    return this;
  }

  getCurrencyToSend() {
    return this.currencyToSend;
  }

  setAmountToReceive(amountToReceive) {
    this.amountToReceive = amountToReceive;
    return this;
  }

  getAmountToReceive() {
    return this.amountToReceive;
  }

  setCurrencyToReceive(currencyToReceive) {
    this.currencyToReceive = currencyToReceive;
    return this;
  }

  getCurrencyToReceive() {
    return this.currencyToReceive;
  }

  setFee(fee) {
    this.fee = fee;
    return this;
  }

  getFee() {
    return this.fee;
  }

  setFeeCurrency(feeCurrency) {
    this.feeCurrency = feeCurrency;
    return this;
  }

  getFeeCurrency() {
    return this.feeCurrency;
  }

  setSenderFirstName(senderFirstName) {
    this.senderFirstName = senderFirstName;
    return this;
  }

  getSenderFirstName() {
    return this.senderFirstName;
  }

  setSenderLastName(senderLastName) {
    this.senderLastName = senderLastName;
    return this;
  }

  getSenderLastName() {
    return this.senderLastName;
  }

  setRecipientFirstName(recipientFirstName) {
    this.recipientFirstName = recipientFirstName;
    return this;
  }

  getRecipientFirstName() {
    return this.recipientFirstName;
  }

  setRecipientLastName(recipientLastName) {
    this.recipientLastName = recipientLastName;
    return this;
  }

  getRecipientLastName() {
    return this.recipientLastName;
  }

  setSenderAccount(senderAccount) {
    this.senderAccount = senderAccount;
    return this;
  }

  getSenderAccount() {
    return this.senderAccount;
  }

  setRecipientAccount(recipientAccount) {
    this.recipientAccount = recipientAccount;
    return this;
  }

  getRecipientAccount() {
    return this.recipientAccount;
  }

  setMetaData(value, key) {
    if (key) this.metaData[key] = value;
    else this.metaData = value;
    return this;
  }

  getMetaData(key) {
    if (key) return (this.metaData || {})[key];
    return this.metaData;
  }
}

export { Transaction };
